import { FileResponse, RetailerDocumentModel } from '../../../../app/services/api/ofdClient';

export const uploadFile = (
  category: string,
  file: File,
  setDocuments: React.Dispatch<React.SetStateAction<RetailerDocumentModel[]>>,
) => {
  if (!category || !file) return;

  const reader = new FileReader();

  reader.onloadend = () => {
    const fileData = reader.result ? reader.result.toString().replace(/^data:(.*,)?/, '') : '';

    setDocuments((prevDocs) =>
      prevDocs.map((doc) =>
        doc.category === category
          ? {
            ...doc,
            fileName: file.name,
            fileType: file.type,
            fileData: fileData,
            delete: false,
          }
          : doc,
      ),
    );
  };
  reader.readAsDataURL(file);
};

export const approveFile = (
  category: string,
  setDocuments: React.Dispatch<React.SetStateAction<RetailerDocumentModel[]>>,
) => {
  if (!category) return;

  setDocuments((prevDocs) =>
    prevDocs.map((doc) =>
      doc.category === category ? { ...doc, approved: !doc.approved } : doc,
    ),
  );
};

export const downloadFile = async (
  docId: number,
  retailerId: number,
  downloadOnboardingDocument: (documentId: number, retailerId: number) => Promise<FileResponse>,
) => {
  try {
    const response = await downloadOnboardingDocument(docId, retailerId);

    if (!(response.data instanceof Blob)) {
      throw new Error('Invalid file data received');
    }

    let filename = 'retailer_document'; // Fallback filename
    const contentDisposition = response.headers?.['content-disposition'];

    if (contentDisposition) {
      const match = contentDisposition.match(/filename\*?=(?:UTF-8''|")(.*?)(?:;|$|")/);
      if (match && match[1]) {
        filename = decodeURIComponent(match[1]);
      }
    }

    const url = window.URL.createObjectURL(response.data);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();

    setTimeout(() => {
      window.URL.revokeObjectURL(url);
      document.body.removeChild(a);
    }, 0);
  } catch (result) {
    console.error(result);
  }
};

export const deleteFile = (
  document: RetailerDocumentModel,
  setDocuments: React.Dispatch<React.SetStateAction<RetailerDocumentModel[]>>,
) => {
  if (!document) return;

  setDocuments((prevDocs) =>
    prevDocs.map((doc) =>
      doc.category === document.category
        ? {
          ...doc,
          delete: !doc.fileData ? !doc.delete : false,
          verified: false,
          fileData: undefined,
          fileName: undefined,
          fileType: undefined,
        }
        : doc,
    ),
  );
};
